import clsx from 'clsx';
import type { InputHTMLAttributes } from 'react';
import styles from './Input.module.css';

export function Input({
  label,
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & { label?: string }) {
  return (
    <label className={styles.wrap}>
      {label ? <span className={styles.label}>{label}</span> : null}
      <input className={clsx(styles.input, className)} {...rest} />
    </label>
  );
}
